import InventoryIcon from "@mui/icons-material/Inventory";
import CategoryIcon from "@mui/icons-material/Category";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PersonIcon from "@mui/icons-material/Person";
import StyleIcon from "@mui/icons-material/Style";
import {SCM_ADMIN_EMAILS } from "../VendorCatalogTheme";



// Used by VendorCatalogFinder 
export const OVERALL_DEFS = [
  { key: "totalCatalogs", label: "Total Catalogs (All Time)", icon: InventoryIcon, colorHex: "#6366f1" },
  { key: "totalVendors", label: "Vendors with Catalogs", icon: StorefrontIcon, colorHex: "#65a30d" },
  { key: "totalCategories", label: "Categories", icon: CategoryIcon, colorHex: "#0d9488" },
  { key: "totalSubCategories", label: "Sub-Categories", icon: AccountTreeIcon, colorHex: "#ea580c" },
  { key: "totalBrands", label: "Brands", icon: StyleIcon, colorHex: "#c026d3" },
];

export const mapOverallStats = (data = {}) => ({
  totalCatalogs: data.totalCatalogs ?? 0,
  totalVendors: data.totalVendors ?? 0,
  totalCategories: data.totalCategories ?? 0,
  totalSubCategories: data.totalSubCategories ?? 0,
  totalBrands: data.totalBrands ?? 0,

});


// "Uploads by SCM User" row — hides the KPI card and name if there are 0
// catalogs by that SCM user, for the current filters/month scope. Only users
// with at least one matching upload get a card.


const SCM_USER_COLOR_PALETTE = [
  "#6366f1", "#0d9488", "#ea580c", "#0284c7", "#65a30d",
  "#dc2626", "#7c3aed", "#c2410c", "#16a34a", "#a21caf",
  "#a16207", "#2563eb", "#0f172a", "#f59e0b",
];

export const getScmDisplayName = (email) => {
  if (!email) return "Unknown";
  const local = email.split("@")[0];
  const parts = local.split(".").filter(Boolean);
  return parts
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1).toLowerCase())
    .join(" ");
};

export const computeScmUserUploadCards = (uploaderCounts = {}) => {
  // Seed every known SCM user with 0 first, so counts are accurate regardless of
  // response ordering, then only keep the ones who actually have uploads.
  const counts = {};
  SCM_ADMIN_EMAILS.forEach((email) => {
    counts[email] = 0;
  });

  // Case-insensitive match against the roster, in case uploadedBy casing differs.
  const emailLookup = new Map(SCM_ADMIN_EMAILS.map((e) => [e.toLowerCase(), e]));

  Object.entries(uploaderCounts).forEach(([email, count]) => {
    const canonical = emailLookup.get(email.toLowerCase());
    if (canonical) counts[canonical] = count;
  });

  const cards = Object.keys(counts)
    .filter((email) => counts[email] > 0) // hide SCM users with zero uploads in this scope
    .sort((a, b) => counts[b] - counts[a]) // busiest first
    .map((email, i) => ({
      key: email,
      label: getScmDisplayName(email),
      icon: PersonIcon,
      colorHex: SCM_USER_COLOR_PALETTE[i % SCM_USER_COLOR_PALETTE.length],
    }));

  return { cards, values: counts };
};